import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">ScrapeWire · Data Simplified</p>
        <h1>Unlock the Power of Web Data</h1>
        <p className="lede">
          At ScrapeWire, we help businesses effortlessly collect and organize vast amounts of web data, turning information into actionable insights.
        </p>
        <div className="cta-row">
          <a href="/services" target="_blank">
            Explore Our Services
          </a>
          <a href="/contact" target="_blank" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Effortless Data Collection</h2>
          <p>
            Our advanced scraping technology allows you to gather data from multiple sources quickly and accurately, saving you time and resources.
          </p>
        </article>
        <article>
          <h2>Organize with Ease</h2>
          <p>
            Transform raw data into structured formats that are easy to analyze and integrate into your existing systems.
          </p>
        </article>
        <article>
          <h2>Stay Ahead of the Competition</h2>
          <p>
            Leverage real-time data insights to make informed decisions and keep your business at the forefront of your industry.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;